import api from "../api/api";

class ManifestoService {
    async getAllPaginate(search: string, page: string | null) {
        let q = '';
        if (search?.length > 0) {
            q = `?q=${search}`;
            q += page ? `&page=${page}` : "";
            return await api.get(`/manifesto${q}`).then(r => r.data).catch(err => err);
        } else {
            if (page) {
                return await api.get(`/manifesto?page=${page}`).then(r => r.data).catch(err => err);
            } else {

                return await api.get(`manifesto`).then(r => r.data).catch(err => err);
            }
        }
    }

    async get(id: string) {
        return await api.get(`/manifesto/${id}`).then(response => response.data).catch(err => err);
    }

    async create(data: any) {
        return await api.post("/manifesto", data).then(response => response.data);
    }

    async update(id: string, data: any) {
        return await api.put(`/manifesto/${id}`, data).then(response => response.data);
    }

    async delete(id: string) {
        return await api.delete(`/manifesto/${id}`).then(response => response.data);
    }

    async statusServico() {
        return await api.get(`/mdfe/status`).then(response => response.data).catch(err => err);
    }

    async transmitir(id: string) {
        return await api.post(`/mdfe/operacao/transmitir/${id}`).then(response => response.data);
    }

    async encerrar(id: string) {
        return await api.post(`/mdfe/operacao/encerrar/${id}`).then(response => response.data);
    }

    async cancelar(id: string) {
        return await api.post(`/mdfe/operacao/cancelar/${id}`).then(response => response.data);
    }

    async damdfe(id: string) {
        return await api.get(`/mdfe/operacao/imprimir/${id}`, {
            responseType: 'blob',
            headers: {
                'Accept': 'application/pdf',
            },
        }).then(response => response.data);
    }


}

const manifestoService = new ManifestoService();

export default manifestoService;